// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"cf32a0f1","218":"3cf78ead","244":"6eb7aec8","635":"4f4d1e2a","894":"6c1bbaa6"}[chunkId] + ".chunk.css";
};